import { login, findUserInfo, findLoginUserInfoByToken, findAgentInfoByUserIdNew, findLoginUserInfo, findByUserIdToList } from "../../service/api.js";
import util from '../../common/utils'

let Base64 = require('js-base64').Base64;

/**
 * 从用户信息的 schoolRoleList 提取学段 phase（去重，逗号分隔）
 * 如 schoolRoleList 里 phase 有 [3, 3, "", ""] -> 返回 "3"
 * 若全部为空或不存在 schoolRoleList -> 返回 ""（表示不限学段，由后端走学校默认）
 */
function extractPhase(data) {
    if (!data || !data.schoolRoleList || data.schoolRoleList.length === 0) {
        return '';
    }
    let phaseList = [];
    data.schoolRoleList.forEach(item => {
        if (item.phase !== '' && item.phase !== null && item.phase !== undefined) {
            let p = String(item.phase);
            if (!phaseList.includes(p)) {
                phaseList.push(p);
            }
        }
    });
    return phaseList.join(',');
}

const user = {
    state: {
        user: {},
        status: '',
        token: util.getCookie("token"),
        name: util.getCookie("name", name) ? util.getCookie("name") : '',
        userId: util.getCookie("userid") ? util.getCookie("userid") : '',
        userName: '',
        userHeadImg: '',
        schoolId: '',
        schoolName: '',
        schoolType: '',
        adminType: util.getCookie("admin_type"),
        userType: '',
        roleIds: '',
        agentId: util.getCookie("agentId"),
        agentName: util.getCookie("agentName"),
        userLoginType: util.getCookie("userLoginType"),
        phase: ''  // 登录用户的学段，从 schoolRoleList 提取，如 "2,3"；为空表示不限学段
    },

    mutations: {
        SET_USER: (state, { user }) => {
            state.user = { user }
        },
        SET_TOKEN: (state, token) => {
            state.token = token
            util.setCookie("token", token)
        },
        SET_STATUS: (state, status) => {
            state.status = status
        },
        SET_NAME: (state, name) => {
            state.name = name

            util.setCookie("name", name)
        },
        SET_USERID: (state, userId) => {
            state.userId = userId
            util.setCookie("userid", userId)
        },
        SET_ADMINTYPE: (state, adminType) => {
            state.adminType = adminType
        },
        SET_USERTYPE: (state, userType) => {
            state.userType = userType
        },
        SET_USERHEADIMG: (state, userHeadImg) => {
            state.userHeadImg = userHeadImg
        },
        SET_USERNAME: (state, userName) => {
            state.userName = userName
        },
        SET_SCHOOLID: (state, schoolId) => {
            state.schoolId = schoolId
        },
        SET_SCHOOLNAME: (state, schoolName) => {
            state.schoolName = schoolName
        },
        SET_AGENTID: (state, agentId) => {
            state.agentId = agentId
        },
        SET_AGENTName: (state, agentName) => {
            state.agentName = agentName
        },
        SET_SCHOOLTYPE: (state, schoolType) => {
            state.schoolType = schoolType
        },
        SET_ROLEIDS: (state, roleIds) => {
            state.roleIds = roleIds;
        },
        SET_PHASE: (state, phase) => {
            state.phase = phase;
        },
    },

    actions: {
        // 用户名登录
        userLogin({ dispatch, commit }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(function (response) {
                    const data = response;
                    commit('SET_USER', data);
                    commit('SET_TOKEN', data.token);
                    commit('SET_ADMINTYPE', data.admin_type);
                    commit('SET_USERTYPE', data.user_type);
                    commit('SET_NAME', data.realname);
                    commit('SET_USERID', data.id);
                    commit('SET_USERNAME', data.user_name);
                    commit('SET_USERHEADIMG', data.avatar);
                    commit('SET_SCHOOLID', data.schoolid);
                    commit('SET_SCHOOLNAME', data.school_name);
                    commit('SET_SCHOOLTYPE', data.school_type);
                    commit('SET_PHASE', extractPhase(data));
                    commit('SET_AGENTID', '');
                    commit('SET_AGENTName', '');
                    commit("SET_FREELOGINORIGIN", '');
                    // document.cookie = "userid=" + data.id + ";path=/";
                    // document.cookie = "realname=" + data.realname + ";path=/";
                    // document.cookie = "schoolid=" + data.schoolid + ";path=/";
                    // document.cookie = "schoolName=" + data.school_name + ";path=/";
                    // document.cookie = "schoolType=" + data.school_type + ";path=/";
                    // document.cookie = "admin_type=" + data.admin_type + ";path=/";
                    // document.cookie = "userType=" + data.user_type + ";path=/";
                    // document.cookie = "account=" + userInfo.account + ";path=/";
                    // document.cookie = "passWord=" + Base64.encode(userInfo.passWord) + ";path=/";
                    // document.cookie = "agentId=;path=/";
                    // document.cookie = "agentName=;path=/";
                    // document.cookie = "freeLoginOrigin=;path=/";
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取用户信息
        getUserInfo({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                let funName = userInfo.token ? findLoginUserInfoByToken : findUserInfo
                funName(userInfo).then(function (response) {
                    const data = response;
                    if (data.token) {
                        commit("SET_TOKEN", data.token);
                    }
                    commit('SET_ADMINTYPE', data.admin_type);
                    commit('SET_USERTYPE', data.user_type);
                    commit('SET_NAME', data.realname);
                    commit('SET_USERID', data.id);
                    commit('SET_USERNAME', data.user_name);
                    commit('SET_USERHEADIMG', data.avatar);
                    commit('SET_SCHOOLID', data.schoolid);
                    commit('SET_SCHOOLNAME', data.school_name);
                    commit('SET_SCHOOLTYPE', data.schoolType);
                    commit('SET_PHASE', extractPhase(data));
                    commit('SET_AGENTID', '');
                    commit('SET_AGENTName', '');
                    // commit("SET_FREELOGINORIGIN", '');
                    // document.cookie = "userid=" + data.id + ";path=/";
                    // document.cookie = "realname=" + data.realname + ";path=/";
                    // document.cookie = "schoolid=" + data.schoolid + ";path=/";
                    // document.cookie = "schoolType=" + data.schoolType + ";path=/";
                    // document.cookie = "admin_type=" + data.admin_type + ";path=/";
                    // document.cookie = "userType=" + data.user_type + ";path=/";
                    // document.cookie = "agentId=;path=/";
                    // document.cookie = "agentName=;path=/";
                    // document.cookie = "freeLoginOrigin=;path=/";
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取用户信息
        getLoginUserInfo({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                let funName = userInfo.token ? findLoginUserInfoByToken : findLoginUserInfo
                funName(userInfo).then(function (response) {
                    const data = response;
                    if (data.token) {
                        commit("SET_TOKEN", data.token);
                    }
                    commit("SET_NAME", data.realname);
                    commit("SET_USERID", data.id);
                    commit("SET_USERNAME", data.user_name);
                    commit("SET_USERHEADIMG", data.avatar);
                    commit("SET_SCHOOLID", data.schoolid);
                    commit("SET_SCHOOLNAME", data.school_name);
                    commit('SET_SCHOOLTYPE', data.school_type);
                    commit("SET_ADMINTYPE", data.admin_type);
                    commit("SET_USERTYPE", data.user_type);
                    commit('SET_PHASE', extractPhase(data));
                    if (userInfo.form != 'areaBoard') {
                        // document.cookie = "token=" + data.token + ";path=/";
                        // document.cookie = "userid=" + data.id + ";path=/";
                        // document.cookie = "realname=" + data.realname + ";path=/";
                        // document.cookie = "schoolid=" + data.schoolid + ";path=/";
                        // document.cookie = "schoolType=" + data.school_type + ";path=/";
                        // document.cookie = "admin_type=" + data.admin_type + ";path=/";
                        // document.cookie = "userType=" + data.user_type + ";path=/";
                        // document.cookie = "agentId=;path=/";
                        // document.cookie = "agentName=;path=/";
                    }
                    resolve(response);
                })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        // 获取用户角色
        getUserRole({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                findByUserIdToList(userInfo)
                    .then(function (response) {
                        if (response) {
                            const data = response;
                            commit("SET_ROLEIDS", data.join(','));
                            resolve(response);
                        } else {
                            reject(response.msg);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        // 根据用户id获取代理商详细信息
        findAgentInfoByUserId({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                findAgentInfoByUserIdNew(userInfo).then(function (response) {
                    const data = response;
                    commit('SET_AGENTID', data.id);
                    commit('SET_AGENTName', data.agentName);
                    util.setCookie("agentId", data.id);
                    util.setCookie("agentName", data.agentName);
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', '');
                commit('SET_ADMINTYPE', '');
                commit('SET_USERTYPE', '');
                commit('SET_NAME', '');
                commit('SET_USERID', '');
                commit('SET_USERHEADIMG', '');
                    commit('SET_AGENTID', '');
                    commit('SET_AGENTName', '');
                    commit('SET_PHASE', '');
                    util.clearCookieByPaths([
                        'token',
                        'userid',
                        'realname',
                        'schoolid',
                        'admin_type',
                        'userType',
                        'schoolType',
                        'userLoginType',
                        'agentId',
                        'agentName'
                    ]);
                    resolve()
            })
        }
    }
}

export default user
